import React, { useState, useEffect } from "react";
import Cuisines from "../components/Cuisines";
import AllCuisinesModal from "../modal/AllCuisinesModal";
import RestaurantsByCuisineModal from "../modal/RestaurantsByCuisineModal";
import { categoryService } from "../services/index";
import { Category } from "../utils/types";

const PopularCuisines = () => {
  const [cuisines, setCuisines] = useState<Category[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedCuisine, setSelectedCuisine] = useState<{
    id: string;
    name: string;
  } | null>(null);
  const [isRestaurantModalOpen, setIsRestaurantModalOpen] = useState<boolean>(false);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const response: any = await categoryService.getCategories({
          page: 1,
          limit: 8,
          sortBy: 'sortOrder',
          sortOrder: 'asc',
          isActive: true
        });
        
        // Handle response based on API structure
        const data = response.data || response;
        setCuisines(Array.isArray(data) ? data : []);
        setError(null);
      } catch (err: any) {
        console.error('Error fetching categories:', err);
        setError(err.message || 'Failed to load categories');
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const handleCuisineClick = (cuisineId: string, cuisineName: string) => {
    setSelectedCuisine({ id: cuisineId, name: cuisineName });
    setIsRestaurantModalOpen(true);
  };

  const handleCloseRestaurantModal = () => {
    setIsRestaurantModalOpen(false);
    setSelectedCuisine(null);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center py-8">
        <p className="text-gray-600 dark:text-gray-400">Loading cuisines...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center py-8">
        <p className="text-red-600 dark:text-red-400">Error: {error}</p>
      </div>
    );
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-3">
        <p className="text-gray-900 dark:text-white text-left font-urbanist text-2xl font-semibold leading-[140%]">
          Popular Cuisines
        </p>
        <p 
          className="text-purple-600 dark:text-purple-400 font-urbanist text-base font-medium cursor-pointer hover:text-purple-800 dark:hover:text-purple-300"
          onClick={() => setIsModalOpen(true)}
        >
          View all
        </p>
      </div>
      
      {/* Grid layout: 4 items per row on mobile, 8 items per row on desktop */}
      <div className="grid grid-cols-4 md:grid-cols-8 gap-3 md:gap-4">
        {cuisines.map((item) => (
          <Cuisines 
            key={item._id} 
            index={item.sortOrder} 
            name={item.name} 
            image={item.image}
            _id={item._id}
            onClick={handleCuisineClick}
          />
        ))}
      </div>

      {/* All Cuisines Modal */}
      <AllCuisinesModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />

      {/* Restaurants by Cuisine Modal */}
      {selectedCuisine && (
        <RestaurantsByCuisineModal
          isOpen={isRestaurantModalOpen}
          onClose={handleCloseRestaurantModal}
          cuisineId={selectedCuisine.id}
          cuisineName={selectedCuisine.name}
        />
      )}
    </div>
  );
};

export default PopularCuisines;
